import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { MenuService } from './services/menu.service';
import { ScreenSizeService } from '../../services/screen-size.service';
import { CookieService } from 'ngx-cookie-service';
import { AuthResponse } from '../../models/auth-request.model';

@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [MenuService],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MenuComponent implements OnInit, OnChanges {
  @Input('menuItems') menuItems: any[];
  @Input('menuParentId') menuParentId: any;
  @Output() toggleMenu: EventEmitter<boolean> = new EventEmitter<boolean>(false);

  userId = '';
  parentMenu: Array<any>;
  toggled: boolean = false;
  isMobile = false;

  constructor(
    public menuService: MenuService,
    private screenSizeService: ScreenSizeService,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private cookieService: CookieService
  ) {
    this.matIconRegistry.addSvgIcon(
      'application-error-icon',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        'assets/images/banner/application-error-icon.svg'
      )
    );
  }

  ngOnInit() {
    const authData = this.cookieService.get('authResponse')
      ? JSON.parse(this.cookieService.get('authResponse')) as AuthResponse
      : null;
    this.userId = authData?.username;

    this.screenSizeService.isSmall$.subscribe(
      (response) => (this.isMobile = response)
    );
  }

  /** Items can change after init (e.g. the ESS message center entry, added once the admin check returns) */
  ngOnChanges(changes: SimpleChanges) {
    if (changes['menuItems'] || changes['menuParentId']) {
      this.parentMenu = (this.menuItems ?? []).filter(
        (item) => item.parentId == this.menuParentId
      );
    }
  }

  onClick(menuId: any) {
    this.menuService.toggleMenuItem(menuId);
    this.menuService.closeOtherSubMenus(this.menuItems, menuId);
    this.toggle();
  }

  toggle() {
    this.toggled = !this.toggled;
    this.toggleMenu.emit(this.toggled);
  }
}
